<button nxButton="primary" type="button" [nxPopoverTriggerFor]="accessibilityPopover" 
  nxPopoverTrigger="click" aria-label="Open accessibility settings menu" 
  class="accessibility-trigger" (click)="onButtonClick()">
  <img src="../../../assets/icons/settings.svg" alt="Decrease font size" aria-hidden="true" class="icon">
</button>

<nx-popover #accessibilityPopover
  direction="bottom-start"
  (nxOpenedChange)="onPopoverToggle($event)">
  <div class="accessibility-content">
    <h4 id="accessibility-title" class="accessibility-title">Accessibility Settings</h4>

    <fieldset class="accessibility-controls" aria-labelledby="accessibility-title">
      <fieldset class="font-size-controls">
        <button nxButton="secondary" nxSize="small" (click)="decreaseFontSize()"
          [disabled]="isDecreaseFontSizeDisabled()" aria-label="Decrease font size" [attr.aria-pressed]="false">
          <img src="../../../assets/icons/text_decrease.svg" alt="Decrease font size" width="16" height="16" class="icon"
            aria-hidden="true">
        </button>
        <button nxButton="secondary" nxSize="small" (click)="increaseFontSize()"
          [disabled]="isIncreaseFontSizeDisabled()" aria-label="Increase font size" [attr.aria-pressed]="false">
          <img src="../../../assets/icons/text_increase.svg" alt="Increase font size" width="16" height="16" class="icon"
            aria-hidden="true">
        </button>
      </fieldset>

      <fieldset class="dark-mode-controls">
        <app-dark-mode-toggle></app-dark-mode-toggle>
      </fieldset>
    </fieldset>

  </div>
</nx-popover>
